import { Card, Form } from 'react-bootstrap';
import { UserData } from './DataDefinitions';
import { useTranslation } from 'react-i18next';
import SettingsChangePassword from './SettingsChangePassword';
interface UserInfoProps {
  user: UserData;
  isAdd: boolean,
  errors: { login?: string, password_mismatch?: string },
  onUserChange: (name: string, value: any) => void;
}

const UserLoginInfo = ({ user, isAdd, errors, onUserChange }: UserInfoProps) => {

  const { t } = useTranslation();

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onUserChange(name, value);
  };

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    onUserChange(name, checked);
  };

  const handlePasswordChange = (fieldName: string, fieldValue: string) => {
    onUserChange(fieldName, fieldValue);
  };

  return (
    <Card className='border border-light' >
      <Card.Body>
        <h4 className="mb-2">{t("UserInfo.user_information")}</h4>

        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="login">{t("UserInfo.login")}</Form.Label>
          <Form.Control
            id="login"
            name="login"
            type="email"
            required
            placeholder="name@example.com"
            className="form-icon-input"
            onChange={handleInputChange}
            isInvalid={!!errors.login}
            value={user.login}
            disabled={!isAdd}
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid email.
          </Form.Control.Feedback>
        </Form.Group>

        <SettingsChangePassword user={user} onPasswordChange={handlePasswordChange} error={errors.password_mismatch} />

        <Form.Floating>

          <Form.Control as="select"
            id="role"
            type="text"
            className="form-icon-input"
            value={user?.role}
            name="role"
            onChange={handleInputChange}
          >
            <option value="super-admin">Super Admin</option>
            <option value="admin">Admin</option>
            <option value="user">User</option>
          </Form.Control>

          <label htmlFor="role" className="form-icon-label text-700">
            {t("UserInfo.role")}
          </label>
        </Form.Floating>

        <div className='mt-3'>
          <Form.Check
            type="checkbox"
            id="disabled"
            name="disabled"
            label="Disabled"
            defaultChecked={user?.disabled}
            onChange={handleCheckChange}
          /></div>


      </Card.Body>
    </Card>
  );
};

export default UserLoginInfo;
